import React, { Component, Fragment } from 'react';
import { getViewEval, getTahunAjaran, getJenis } from '../../services/api-services/evaluasi-api';
import PertanyaanDosen from './PertanyaanDosen';
import PertanyaanNonDosen from './PertanyaanNonDosen';
import { getUser } from '../../services/api-services/krs-api';

const initialState = {
    listTahunAjaran: [],
    dataMhs: [],
    listJenis: [],
    listDataEval: [],
    listDataSarpras: [],
    isLoad: false,
    idjenis: '',
    jenis: '',
    // data akademik
    akademik: {
        validasi: '',
        ta: '',
        smtta: '',
        semester: ''
    }
}

class Evaluasi extends Component {
    constructor(props) {
        super(props)
        this.state = initialState
    }

    handleInput = (e) => {
        this.setState({ [e.target.name]: e.target.value })
        if (e.target.name == 'idjenis') {
            this.setState({
                validasi: e.target.options[e.target.selectedIndex].text
            })
        }
    };

    getAllData = async () => {
        const allPromise = Promise.all([
            getUser(localStorage.getItem('nim')),
        ])
        const promises = await allPromise
        this.setState({
            dataMhs: promises[0].data,
        })
    }

    getFilter = async () => {
        const datas = await Promise.all([
            getTahunAjaran(),
            getJenis()
        ])
        this.setState({
            listTahunAjaran: datas[0].data.data ?? [],
            listJenis: datas[1].data.data ?? []
        })
    }

    handleView = async (e) => {
        e.preventDefault();
        this.setState({ isLoad: true })
        const params = {
            nim: this.props.dataMhs.nim,
            ta: this.state.dataMhs.ta,
            smtta: this.state.dataMhs.smtta,
            kurikulum: this.props.dataMhs.kurikulum,
            idjenis: this.state.idjenis,
            idfakultas: this.props.dataMhs.idfakultas
        }
        const response = await getViewEval(params)
        if (response) {
            var text = this.state.validasi.toLowerCase()
            if (text.match(/dosen.*/)) { this.setState({ jenis: 'dosen' }) }
            else if (text.match(/pegawai.*/)) {
                { this.setState({ jenis: 'Pegawai' }) }
            } else {
                { this.setState({ jenis: 'Sarpras' }) }
            }
            this.setState({
                listDataEval: response.data.evaluasi_dosen,
                listDataSarpras: response.data.evaluasi_sarpras,
                akademik: {
                    validasi: response.data.evaluasi_dosen[0]?.validasi ?? "",
                    ta: response.data.ta ?? "",
                    smtta: response.data.smtta ?? "",
                    semester: response.data.semester ?? ""
                }
            })
        }
    }

    componentDidMount() {
        this.getFilter()
        this.getAllData()

    }

    render() {
        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{
                                fontSize: '15px', fontWeight: 'bold', color: '#999999',
                                textTransform: 'capitalize'
                            }}>
                                Evaluasi&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Pertanyaan
                            </p>
                        </div>
                    </div>
                </div>
                <div className="smooth">
                    <div className="card card-custom mb-3 pl-3 pr-3">
                        <form onSubmit={this.handleView}>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-4 mt-2 mb-2">
                                        <select className="form-control" name="ta" onChange={this.handleInput} disabled={this.state.dataMhs.ta && this.state.listTahunAjaran.find(list => list.ajaran === this.state.dataMhs.ta) ? true : false}>
                                            <option hidden>- Tahun Akademik -</option>
                                            {
                                                this.state.listTahunAjaran.map((list, i) => {
                                                    return (
                                                        <option key={i} value={list.ajaran} selected={this.state.dataMhs.ta === list.ajaran}>{list.ajaran}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-4 mt-2 mb-2">
                                        <select className="form-control" name="smtta" onChange={this.handleInput} disabled={this.state.dataMhs.smtta == '1' || this.state.dataMhs.smtta == '2'}>
                                            <option value=''>- Semester -</option>
                                            <option value='1' selected={this.state.dataMhs.smtta == '1'}>Ganjil</option>
                                            <option value='2' selected={this.state.dataMhs.smtta == '2'}>Genap</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 mt-2 mb-2">
                                        <select className="form-control" name="idjenis" onChange={this.handleInput}>
                                            <option value="">- Jenis -</option>
                                            {this.state.listJenis.map((list, i) => {
                                                return (
                                                    <option key={i} value={list.idjenis} >{list.jenis}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                    <div className='col-lg-12 mt-2 mb-2'>
                                        <p align="right">
                                            <button className="btn btn-success">
                                                Cari Data
                                            </button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <br />
                    {
                        this.state.jenis == 'dosen' ?
                            <PertanyaanDosen
                                idjenis={this.state.idjenis}
                                dataMhs={this.props.dataMhs}
                                data={this.state.listDataEval}
                                dataSarpras={this.state.listDataSarpras}
                                refresh={this.handleView}
                            /> :
                            this.state.jenis == 'Pegawai' || this.state.jenis == 'Sarpras' ?
                                <PertanyaanNonDosen
                                    akademik={this.state.akademik}
                                    jenis={this.state.jenis}
                                    idjenis={this.state.idjenis}
                                    dataMhs={this.props.dataMhs}
                                    data={this.state.listDataEval}
                                    refresh={this.handleView}
                                />
                                : null
                    }
                </div>
            </Fragment >
        )
    }
}

export default Evaluasi
